import React from "react";
import { GetStaticProps } from "next";
import { PrivacyPolicyData } from "@components/CMSPage";
import CmsPageContainer, {
  TCmsPageContainer,
} from "@components/CMSPage/CmsPageContainer";

const PPPage: React.FC<TCmsPageContainer> = (pageData: TCmsPageContainer) => {
  return <CmsPageContainer {...pageData} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const ppData: TCmsPageContainer = PrivacyPolicyData;
  return {
    props: {
      ...ppData,
    },
  };
};

export default PPPage;
